module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "abb"
    }
  }), _vm._v("List of Abbreviations")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_vm._v("WORKS BY HANS-GEORG GADAMER")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablex"
  }, [_c('em', [_vm._v("BP")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabley"
  }, [_c('em', [_vm._v("The Beginning of Philosophy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("CPA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Century of Philosophy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("HD")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Hegel’s Dialectic")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("GW")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Gesammelte Werke")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GW 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_vm._v("Hermeneutik I: Wahrheit und Methode")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GW 2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_vm._v("Hermeneutik II: Wahrheit und Methode, Ergänzungen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GW 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_vm._v("Neuere Philosophie I: Hegel, Husserl, Heidegger")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GW 4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_vm._v("Neuere Philosophie II: Probleme, Gestalten")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GW 8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_vm._v("Ästhetik und Poetik I: Kunst als Aussage")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GW 10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_vm._v("Hermeneutik im Rückblick")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("PH")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Philosophical Hermeneutics")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("RAS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Reason in the Age of Science")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("TM")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Truth and Method")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3y"
  }, [_vm._v("WORKS BY G. W. F. HEGEL")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('em', [_vm._v("IPH")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Introduction to the Philosophy of History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("PR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Philosophy of Right")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("PS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Phenomenology of Spirit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("RH")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Reason in History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("SL")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Science of Logic")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3y"
  }, [_vm._v("WORKS BY MARTIN HEIDEGGER")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("BW")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Basic Writings")]), _vm._v(", ed. by Krell")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("GA")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Gesamtausgabe")]), _vm._v(" (volume numbers listed in bibliography)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("HR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("The Heidegger Reader")]), _vm._v(", ed. by Figal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("SZ")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Sein und Zeit")]), _vm._v(", Niemeyer edition")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3y"
  }, [_vm._v("WORKS BY IMMANUEL KANT")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("CJ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Critique of Judgment")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("CPR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Critique of Pure Reason")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3y"
  }, [_vm._v("OTHER FREQUENTLY CITED VOLUMES")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("DH")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Dimensionen des Hermeneutischen")]), _vm._v(", ed. by Figal and Gander")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("GC")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Gadamer’s Century")]), _vm._v(", ed. by Malpas, Arnswald, and Kertscher")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('em', [_vm._v("HAC")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Gadamer’s Hermeneutics and the Art of Conversation")]), _vm._v(", ed. Andrzej Wiercinski")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("HVO")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Hermeneutics and the Voice of the Other")]), _vm._v(", by Risser")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("HW")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Hermeneutische Wege")]), _vm._v(", ed. by Figal, Grondin, and Schmidt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("KA 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Sein und Zeit")]), _vm._v(", ed. by Rentsch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_vm._v("KA 30")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("Wahrheit und Methode")]), _vm._v(", ed. by Figal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablext"
  }, [_c('em', [_vm._v("SR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tableyt"
  }, [_c('em', [_vm._v("The Specter of Relativism")]), _vm._v(", ed. by Schmidt")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53dde613","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 84
// module chunks = 0